var map = {
	"./i18n.json": 1772,
	"./i18n_da.json": 9408,
	"./i18n_de.json": 9728,
	"./i18n_en-GB.json": 5144,
	"./i18n_en.json": 3122,
	"./i18n_es.json": 5114,
	"./i18n_fr.json": 7988,
	"./i18n_nl.json": 3464,
	"./i18n_sv.json": 8427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2812;